import React from 'react'
import { connect } from 'react-redux'
import allRoles from '../../roles/roles'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, getListItems } from '../../public/utility'
import { concat } from 'lodash'

class EvaluateContentDiv extends React.Component {
    state = {}
    componentDidMount = () => {
        const { id } = this.props
        Tyan.doPostEvent({
            event: 'GetEvaluateContent',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ id, initValues基本信息, changedValues基本信息: {} })
            }
        })
    }

    handlerSave = () => {
        const { evaluateTitleID, id, onClose, onSave } = this.props
        const { changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'SaveEvaluateContent',
            data: { evaluateTitleID, id, changedValues基本信息 },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('保存成功')
                onClose && onClose()
                onSave && onSave()
            }
        })
    }

    handlerDelete = () => {
        const { id, onClose, onSave } = this.props
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteEvaluateContent',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    onClose && onClose()
                    onSave && onSave()
                }
            }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '评价内容')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _text: '评价内容', minWidth: '95%', required: true },
            { _int: '分值', minWidth: '95%', textAlign: 'left' },
            { _text: '考核标准及分值', minWidth: '95%' }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { errorMessage, initValues基本信息, bReadOnly } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        if (errorMessage) return <Message text={errorMessage} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="700"
            controls={
                bReadOnly ?
                    [
                        { _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ] : [
                        { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                        { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                        { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(EvaluateContentDiv)